import {
  Copyright,
  FooterWrapper,
  InstagramLink,
  SocialContainer,
  SocialText,
} from './styles'

const year = new Date().getFullYear()

const Footer = () => (
  <FooterWrapper>    
    <SocialContainer>
      <SocialText>Siga-nos no Instagram</SocialText>
      <InstagramLink
        href="https://www.instagram.com/orul_tech/"
        target="_blank"
        rel="noreferrer"
        aria-label="Instagram da Orul"
      >
        <img
          src="/assets/images/logoInstagram.png"
          alt="Instagram"
          width={20}
          height={20}
        />
      </InstagramLink>
    </SocialContainer>

    <Copyright>
      ©{year} Orul Tecnologia. Todos os direitos reservados.
    </Copyright>
  </FooterWrapper>
)

export default Footer
